<template>
  <Flex grow component-list column border>
    <Flex>
      <DesignerActionBar component-name="Status" :add-component="onAddComponentClick">
      </DesignerActionBar>
    </Flex>
    <Flex component-list>
      <Flex v-for="(node, index) in root.children" :key="index" v-on:click="onListItemClick(index)">
        <StateListItem
          :node="root.children[index]"
          :index="index + 1"
          :class="{ selected: selectedListItem === index }"
          :is-invalid="invalidStatuses.includes(index) || asyncInvalidStatuses.includes(index)"
        />
      </Flex>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import StateListItem from '@/components/designer/StateListItem'
import DesignerActionBar from '@/components/designer/DesignerActionBar'

export default {
  name: 'StateList',
  components: {
    DesignerActionBar,
    Flex,
    StateListItem,
  },
  props: {
    selectedListItem: Number,
    root: Object,
    addState: Function,
    invalidStatuses: Array,
    asyncInvalidStatuses: Array,
  },
  data() {
    return {}
  },
  methods: {
    onAddComponentClick() {
      this.addState(this.root)
      this.$emit('update:selectedListItem', this.root.children ? this.root.children.length : 0)
    },
    onListItemClick(index) {
      this.$emit('update:selectedListItem', index)
    },
  },
}
</script>

<style scoped>
.component-list {
  @apply flex flex-col text-xs text-gray-700 overflow-auto text-sm;

  &--active-target,
  .selected {
    @apply bg-gray-200;
  }
}
</style>
